// extracted by mini-css-extract-plugin
export default {"card":"styles_card__ZdacR","value":"styles_value__7cZ7v","title":"styles_title__qBIRi","description":"styles_description__oiSC8"};